<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">
        <a class="nav-link" routerLink="/TypesProximitiesPage">TypesProximitiesPage</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/premisehazardrecord">PremiseHazardRecord</a>
      </li>
      <msi-select
        [formControl]="currentAgencyRoot"
        *ngIf="isParentAgencyAdminUser"
        placeholder="Select Value"
        id="mainpage1"
      >
        <msi-select-option *ngFor="let agency of agencyList" [value]="agency">
          {{ agency }}
        </msi-select-option>
      </msi-select>
    </ul>
  </div>
</nav>
<router-outlet></router-outlet>
